import { build } from "app/main/tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: '/oauth-link',
		component: lazy(() => import('./OAuthLink'))
	},
]);